import { createFeature, createReducer, on } from '@ngrx/store';
import { MetaData, Supplier } from '@emi/shared/models';
import * as supplierActions from './supplier-actions';
import * as commonActions from '../common-actions';

export interface SupplierState {
    suppliers: Supplier[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const supplierFeatureKey = 'supplierFilter';

const initialState: SupplierState = {
    suppliers: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const supplierFeature = createFeature({
    name: supplierFeatureKey,
    reducer: createReducer(
        initialState,
        on(supplierActions.isLoadingSuppliers, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(supplierActions.getNextPageSuppliers, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(supplierActions.getSuppliersSuccess, (state, { suppliers, metadata, searchText }) => {
            return {
                ...state,
                suppliers,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(supplierActions.getSuppliersFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(supplierActions.updateSuppliersSelectionSuccess, (state, { suppliers, metadata }) => {
            return {
                ...state,
                suppliers: [...state.suppliers, ...suppliers],
                metadata,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(supplierActions.searchSuppliers, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
